export const FETCH_GENERAL_DETAILS_REQUEST = 'FETCH_GENERAL_DETAILS_REQUEST';
export const FETCH_GENERAL_DETAILS_SUCCESS = 'FETCH_GENERAL_DETAILS_SUCCESS';
export const FETCH_GENERAL_DETAILS_FAILURE = 'FETCH_GENERAL_DETAILS_FAILURE';

export const fetchGeneralDetailsRequest = (courseInstanceID: number | string) => ({
    type: FETCH_GENERAL_DETAILS_REQUEST,
    payload: { courseInstanceID },
});

export const fetchGeneralDetailsSuccess = (data: any) => ({
    type: FETCH_GENERAL_DETAILS_SUCCESS,
    payload: data,
});

export const fetchGeneralDetailsFailure = (error: string) => ({
    type: FETCH_GENERAL_DETAILS_FAILURE,
    payload: error,
});
